import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-why-choose-us',
    templateUrl: './why-choose-us.component.html',
    styleUrls: ['./why-choose-us.component.scss']
})
export class WhyChooseUsComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

   whyChooseContent = [
  {
    subTitle: 'WHY CHOOSE US',
    title: "The Story, Passion, and Magic Behind Every Dish",
    paragraph: 'Kitchen Magic was born from tradition, family memories, and a deep love for authentic cooking. What started around a firewood stove filled with laughter, smoky aromas, and joyful gatherings became a lifelong dream to share heartfelt food experiences with the world.',
    content: [
      {
        title: 'Rooted in Tradition, Inspired by Family',
        paragraph: 'The foundation of Kitchen Magic comes from the cooking legacy of Nagarajan’s father and the “magic touch” inspired by his mother. The name itself — “K” from Kala and “M” from Murugan — is a tribute to the two souls who shaped this journey and inspired a passion for authentic flavors.'
      },
      {
        title: 'Blending South Indian Roots with Global Flavors',
        paragraph: 'While South Indian cuisine remains at the heart of our kitchen, Nagarajan’s travels across India and the world inspired a thoughtful blend of multiple cuisines. Every dish carries traditional authenticity combined with modern creativity, all prepared with the same Kitchen Magic concept.'
      },
      {
        title: 'More Than Food — A Place for Connection',
        paragraph: 'Kitchen Magic is not just about food delivery. From our food truck to our cloud kitchen, we created a space where food, stories, culture, and people come together. Every meal is crafted to recreate the warmth, joy, and connection of those early family gatherings.'
      }
    ]
  }
];
    whyChooseImage = [
        {
            img: 'assets/img/km_food_truck.jpeg'
           
        }
    ]

}
